import { StaticImageData } from 'next/image';
import { Platform } from 'react-native';
import { Image } from 'shared/components/image';

type SvgIconProps = {
  src: string | StaticImageData;
  alt?: string;
  containerClassName?: string;
  imageClassName?: string;
  draggable?: boolean;
};

export function SvgImage({
  src,
  containerClassName,
  imageClassName,
  alt,
  draggable,
}: SvgIconProps) {
  if (Platform.OS === 'web') {
    return (
      <Image
        src={src}
        containerClassName={containerClassName}
        imageClassName={imageClassName}
        alt={alt}
        draggable={draggable}
      />
    );
  } else if (typeof src === 'string') {
    // implement RN svg, make separate files (svg-image/index.tsx etc)
    return null;
    // import { SvgXml } from 'react-native-svg';
    // return <SvgXml xml={src} />;
  }

  throw 'Invalid SVG...';
}
